/* eslint-disable camelcase */
export default class CheckoutAddresses {
    constructor() {
        // SOAP on the server must be enabled!
        this.events();
    }

    events() {
        (function ($) {
            $(document).ready(function () {
                $("#multiple_address_shipping, #multiple_address_billing").on(
                    "change",
                    function () {
                        const type = $(this).attr("id").split("_").pop();
                        const container = $(".woocommerce-" + type + "-fields");

                        // Add loader
                        container.block({
                            message: null,
                            overlayCSS: {
                                cursor: "none",
                                background: "#fff",
                                opacity: 0.6,
                            },
                        });

                        $.post(
                            ajax.ajaxurl,
                            {
                                action: "checkout_change_address",
                                id: $(this).val(),
                            },
                            function (response) {
                                const obj = JSON.parse(response);
                                $("#" + type + "_company").val(
                                    obj.shipping_company
                                );
                                $("#" + type + "_first_name").val(
                                    obj.shipping_first_name
                                );
                                $("#" + type + "_last_name").val(
                                    obj.shipping_last_name
                                );
                                $("#" + type + "_address_1").val(
                                    obj.shipping_address_1
                                );
                                $("#" + type + "_address_2").val(
                                    obj.shipping_address_2
                                );
                                $("#" + type + "_city").val(obj.shipping_city);
                                $("#" + type + "_country")
                                    .val(obj.shipping_country)
                                    .change();
                                $("#" + type + "_country_chosen")
                                    .find("span")
                                    .html(obj.shipping_country_text);

                                $("#" + type + "_province_field")
                                    .val(obj.shipping_province_field)
                                    .change();
                                $("#" + type + "_province_field_chosen")
                                    .find("span")
                                    .html(obj.shipping_province_field);

                                $("#" + type + "_postcode").val(
                                    obj.shipping_postcode
                                );
                                $("#" + type + "_state").val(
                                    obj.shipping_state
                                );
                                $("#" + type + "_province_field").val(
                                    obj.shipping_province_field
                                );

                                const stateName = $(
                                    "#" +
                                        type +
                                        '_state option[value="' +
                                        obj.shipping_state +
                                        '"]'
                                ).text();
                                $("#s2id_" + type + "_state")
                                    .find(".select2-chosen")
                                    .html(stateName)
                                    .parent()
                                    .removeClass("select2-default");
                            }
                        )
                            .done(function () {
                                $(".blockUI").remove();
                            })
                            .fail(function (xhr, textStatus, errorThrown) {
                                alert(xhr.responseText);
                            });
                        return false;
                    }
                );

                // wc_country_select_params is required to continue, ensure the object exists
                if (typeof wc_country_select_params === "undefined") {
                    return false;
                }

                /* State/Country select boxes */
                const states_json = wc_country_select_params.countries.replace(
                    /&quot;/g,
                    '"'
                );
                const states = $.parseJSON(states_json);

                $(document)
                    .on(
                        "change",
                        "select.country_to_state, input.country_to_state",
                        function () {
                            const country = $(this).val();
                            let $statebox = $(this)
                                .closest("div")
                                .find(
                                    "#billing_state, #shipping_state, #calc_shipping_state"
                                );
                            const $parent = $statebox.parent();
                            const input_name = $statebox.attr("name");
                            const input_id = $statebox.attr("id");
                            const value = $statebox.val();
                            const placeholder = $statebox.attr("placeholder");

                            if (states[country]) {
                                if (states[country].length === 0) {
                                    $statebox
                                        .parent()
                                        .hide()
                                        .find(".chosen-container")
                                        .remove();
                                    $statebox.replaceWith(
                                        '<input type="hidden" class="hidden" name="' +
                                            input_name +
                                            '" id="' +
                                            input_id +
                                            '" value="" placeholder="' +
                                            placeholder +
                                            '" />'
                                    );

                                    $("body").trigger(
                                        "country_to_state_changed",
                                        [country, $(this).closest("div")]
                                    );
                                } else {
                                    let options = "";
                                    const state = states[country];
                                    for (const index in state) {
                                        if (state.hasOwnProperty(index)) {
                                            options =
                                                options +
                                                '<option value="' +
                                                index +
                                                '">' +
                                                state[index] +
                                                "</option>";
                                        }
                                    }

                                    $statebox.parent().show();

                                    if ($statebox.is("input")) {
                                        // Change for select
                                        $statebox.replaceWith(
                                            '<select name="' +
                                                input_name +
                                                '" id="' +
                                                input_id +
                                                '" class="state_select" placeholder="' +
                                                placeholder +
                                                '"></select>'
                                        );
                                        $statebox = $(this)
                                            .closest("div")
                                            .find(
                                                "#billing_state, #shipping_state, #calc_shipping_state"
                                            );
                                    }

                                    $statebox.html(
                                        '<option value="">' +
                                            wc_country_select_params.i18n_select_state_text +
                                            "</option>" +
                                            options
                                    );

                                    $statebox.val(value);

                                    $("body").trigger(
                                        "country_to_state_changed",
                                        [country, $(this).closest("div")]
                                    );
                                }
                            } else {
                                if ($statebox.is("select")) {
                                    $parent
                                        .show()
                                        .find(".chosen-container")
                                        .remove();
                                    $statebox.replaceWith(
                                        '<input type="text" class="input-text" name="' +
                                            input_name +
                                            '" id="' +
                                            input_id +
                                            '" placeholder="' +
                                            placeholder +
                                            '" />'
                                    );

                                    $("body").trigger(
                                        "country_to_state_changed",
                                        [country, $(this).closest("div")]
                                    );
                                } else if ($statebox.is(".hidden")) {
                                    $parent
                                        .show()
                                        .find(".chosen-container")
                                        .remove();
                                    $statebox.replaceWith(
                                        '<input type="text" class="input-text" name="' +
                                            input_name +
                                            '" id="' +
                                            input_id +
                                            '" placeholder="' +
                                            placeholder +
                                            '" />'
                                    );

                                    $("body").trigger(
                                        "country_to_state_changed",
                                        [country, $(this).closest("div")]
                                    );
                                }
                            }

                            $("body").trigger("country_to_state_changing", [
                                country,
                                $(this).closest("div"),
                            ]);
                        }
                    )
                    .change();
            });
        })(jQuery);
    }
}
